export const USER_QUESTION_CHARACTER_LIMIT = 250;

export const keyPressMap = { Enter: false, Shift: false };

export const FALLBACK_SESSION_ID = 'fallback-sessionId';
export const FALLBACK_USER_ID = 'fallback-userId';

export const MESSAGE_ORIGIN_PREPOPULATED = 'prepopulated';
export const MESSAGE_ORIGIN_CUSTOM = 'custom';
export const MESSAGE_ORIGIN_UNSPECIFIED = 'unspecified';
export const MESSAGE_ORIGIN_RETRY = 'retry';

export const ASK_A_QUESTION_ANALYTICS_PLACEHOLDER = 'ask a question clicked';
export const FEEDBACK_ANALYTICS_MAA_PRIMARY_CATEGORY = 'magic apron';
export const FEEDBACK_ANALYTICS_MAA_EVENT_NAME_PREFIX = 'maa feedback';
export const FEEDBACK_ANALYTICS_QNA_PRIMARY_CATEGORY = 'magic apron';
export const FEEDBACK_ANALYTICS_QNA_EVENT_NAME_PREFIX = 'ma qna feedback';
export const FEEDBACK_CLICK_COMMENT_QUESTION_ORIGIN_MAA = 'maa';
export const FEEDBACK_CLICK_COMMENT_QUESTION_ORIGIN_QNA = 'ma qna';

export const RETRY_MESSAGE = {
  type: 'bot',
  content: {
    responseSummary: {
      summaryAnswer: 'The conversation was interrupted before I could finish finding the answer.',
    },
  },
};

export const isAPI = true; // setting constant to true to indicate API page type
export const PAGE_TYPES = {
  HOME: 'HOME',
  CONTENT: 'CONTENT',
  PIP: 'PIP',
  PLP: 'PLP',
  BROWSE: 'BROWSE',
  SEARCH: 'SEARCH',
  BIP: 'BIP',
  UNKNOWN: 'UNKNOWN',
};
